<template>
	<div class="banner">
		<!--<div class="container-fluid">
			<img class="img-fluid" src="../../../assets/img/index.jpg" />
		</div>-->
		<div class="container">
			<div class="row banner-text">
				<div class="slider-info col-lg-6">
					<div class="agileinfo-logo pl-2">
						<h4 style="margin-top: 0.1em;">专为青少年打造的全方位编程平台</h4>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 自主研发的编程平台，孩子轻松学</p>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 趣味教学互动，让孩子喜欢上编程</p>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 软件+硬件编程，在实践中学习</p>
						<p><span class="fa fa-check-square-o" aria-hidden="true"></span> 流畅学习体验，提升学习效率</p>
					</div>
					<a @click="coding1" class="btn mr-3 text-capitalize ml-2" href="javascript:void(0)">机器人编程</a>
					<a @click="coding2" class="btn mr-3 text-capitalize" href="javascript:void(0)">图形化编程</a>
					<a @click="coding3" class="btn text-capitalize mr-3" href="javascript:void(0)">代码式编程</a>
				</div>
				<div class="slider-info col-lg-6">
					<img src="../../../assets/img/index_banner.png" class="img-fluid" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import CommonHeader from '@/pages/common/Header'
	var header = CommonHeader
	export default {
		name: 'HomeBanner',
		methods: {
			coding1() {
				if(this.$store.state.loginFlag) {
					this.getClassList(1, "https://file.itmsw.com/coding/course/m-coding-ms.html")
				} else {
					header.methods.login()
				}
			},
			coding2() {
				if(this.$store.state.loginFlag) {
					this.getClassList(2, "https://file.itmsw.com/coding/course/v-coding-ms.html")
				} else {
					header.methods.login()
				}
			},
			coding3() {
				if(this.$store.state.loginFlag) {
					this.getClassList(3, "https://file.itmsw.com/coding/course/coding-ms.html")
				} else {
					header.methods.login()
				}
			},
			getClassList(id, uri) {
				$.confirm({
					theme: 'modern',
					title: '',
					content: '<span class=\'itmsw_ft_1\'>请选择年份！</span>',
					icon: 'fa fa-question-circle',
					closeIcon: false,
					animation: 'scale',
					type: 'blue',
					closeAnimation: 'scale',
					opacity: 0.5,
					buttons: {
						'confirm': {
							text: '2022年',
							btnClass: 'btn-blue',
							action: function() {
								axios.get('/itmswcn/maintain/classInfo/queryList/type/2022/' + id)
									.then(function(res) {
										var html = "",
											data = res.data;
										if(data.code == 100) {
											data = data.data;
											$.each(data, function(i) {
												if(i == 0) {
													html += "<p class='confirm-p'><label><span class='confirm-span1'><input type='radio' name='tcRadio' value='" + data[i].id + "' checked='checked' /></span><span class='confirm-span3'>" + data[i].className + "</span></label></p>"
												} else {
													html += "<p class='confirm-p'><label><span class='confirm-span1'><input type='radio' name='tcRadio' value='" + data[i].id + "' /></span><span class='confirm-span3'>" + data[i].className + "</span></label></p>"
												}
											});
										} else {
											var classname = "";
											if(id == 1) {
												classname = "码速网机器人编程默认班级";
											} else if(id == 2) {
												classname = "码速网图形化编程默认班级";
											} else {
												classname = "码速网代码式编程默认班级";
											}
											html += "<p class='confirm-p'><label><span class='confirm-span1'><input type='radio' name='tcRadio' value='0' checked='checked' /></span><span class='confirm-span3'>" + classname + "</span></label></p>"
										}
										$.confirm({
											title: '<span class=\'itmsw_ft_1\'><i class="fa fa-check-square-o"></i>请选择班级！</span>',
											content: html,
											theme: 'modern',
											closeIcon: false,
											animation: 'scale',
											type: 'blue',
											boxWidth: '400px',
											useBootstrap: false,
											backgroundDismiss: false,
											buttons: {
												yes: {
													text: '确认', // text for button
													btnClass: 'itmsw_bt_confirm_1', // class for the button
													keys: ['y'], // keyboard event for button
													isHidden: false, // initially not hidden
													isDisabled: false, // initially not disabled
													action: function(yesButton) {
														var cid = $("input[name=tcRadio]:checked").val();
														window.open(uri + "?cid=" + cid + "&timeStamp=" + new Date().getTime());
													}
												},
												no: {
													text: '取消', // text for button
													btnClass: 'itmsw_bt_confirm_2', // class for the button
													keys: ['n'], // keyboard event for button
													isHidden: false, // initially not hidden
													isDisabled: false, // initially not disabled
													action: function(noButton) {}
												}
											}
										});
									})
							}
						},
						moreButtons: {
							text: '2023年',
							btnClass: 'btn-red',
							action: function() {
								axios.get('/itmswcn/maintain/classInfo/queryList/type/2023/' + id)
									.then(function(res) {
										var html = "",
											data = res.data;
										if(data.code == 100) {
											data = data.data;
											$.each(data, function(i) {
												if(i == 0) {
													html += "<p class='confirm-p'><label><span class='confirm-span1'><input type='radio' name='tcRadio' value='" + data[i].id + "' checked='checked' /></span><span class='confirm-span3'>" + data[i].className + "</span></label></p>"
												} else {
													html += "<p class='confirm-p'><label><span class='confirm-span1'><input type='radio' name='tcRadio' value='" + data[i].id + "' /></span><span class='confirm-span3'>" + data[i].className + "</span></label></p>"
												}
											});
										} else {
											var classname = "";
											if(id == 1) {
												classname = "码速网机器人编程默认班级";
											} else if(id == 2) {
												classname = "码速网图形化编程默认班级";
											} else {
												classname = "码速网代码式编程默认班级";
											}
											html += "<p class='confirm-p'><label><span class='confirm-span1'><input type='radio' name='tcRadio' value='0' checked='checked' /></span><span class='confirm-span3'>" + classname + "</span></label></p>"
										}
										$.confirm({
											title: '<span class=\'itmsw_ft_1\'><i class="fa fa-check-square-o"></i>  请选择班级进行编程学习：</span>',
											content: html,
											theme: 'modern',
											closeIcon: false,
											animation: 'scale',
											type: 'blue',
											boxWidth: '400px',
											useBootstrap: false,
											backgroundDismiss: false,
											buttons: {
												yes: {
													text: '确认', // text for button
													btnClass: 'itmsw_bt_confirm_1', // class for the button
													keys: ['y'], // keyboard event for button
													isHidden: false, // initially not hidden
													isDisabled: false, // initially not disabled
													action: function(yesButton) {
														var cid = $("input[name=tcRadio]:checked").val();
														window.open(uri + "?cid=" + cid + "&timeStamp=" + new Date().getTime());
													}
												},
												no: {
													text: '取消', // text for button
													btnClass: 'itmsw_bt_confirm_2', // class for the button
													keys: ['n'], // keyboard event for button
													isHidden: false, // initially not hidden
													isDisabled: false, // initially not disabled
													action: function(noButton) {}
												}
											}
										});
									})
							}
						},
						no: {
							text: '取消'
						}
					}
				});
			},
			tochart() {
				if(this.$store.state.loginFlag) {
					if(this.$store.state.authcode == 10 || this.$store.state.authcode == 3) {
						window.open("https://itmsw.com/chart/home.html")
					} else {
						$.alert({
							title: '',
							content: '<span class="itmsw_ft_1" style="line-height:36px;"><i class="fa fa-check-square-o"></i> 抱歉，您暂时无权加入<br>&nbsp;&nbsp;&nbsp;&nbsp;详情请咨询授课老师。</span>',
							theme: 'modern',
							closeIcon: false,
							animation: 'scale',
							type: 'blue',
							boxWidth: '380px',
							useBootstrap: false,
							backgroundDismiss: true,
							buttons: {
								yes: {
									text: '确认', // text for button
									btnClass: 'itmsw_bt_confirm_3', // class for the button
									keys: ['y'], // keyboard event for button
									isHidden: false, // initially not hidden
									isDisabled: false, // initially not disabled
									action: function(yesButton) {}
								}
							}
						});
					}
				} else {
					header.methods.login()
				}
			},
			tolive() {
				if(this.$store.state.loginFlag) {
					if(this.$store.state.authcode == 10) {
						if(this.$store.state.roleId == 2) {
							this.$router.push({
								path: '/teach/center'
							})
						} else {
							this.$router.push({
								path: '/learn/center'
							})
						}
					} else {
						$.alert({
							title: '',
							content: '<span class="itmsw_ft_1" style="line-height:36px;"><i class="fa fa-check-square-o"></i> 抱歉，您还没有直播课<br>&nbsp;&nbsp;&nbsp;&nbsp;详情请咨询授课老师。</span>',
							theme: 'modern',
							closeIcon: false,
							animation: 'scale',
							type: 'blue',
							boxWidth: '380px',
							useBootstrap: false,
							backgroundDismiss: true,
							buttons: {
								yes: {
									text: '确认', // text for button
									btnClass: 'itmsw_bt_confirm_3', // class for the button
									keys: ['y'], // keyboard event for button
									isHidden: false, // initially not hidden
									isDisabled: false, // initially not disabled
									action: function(yesButton) {}
								}
							}
						});
					}
				} else {
					header.methods.login()
				}
			}
		},
		mounted() {}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/home/components/HomeBanner.scss';
</style>